module.exports = __webpack_public_path__ + "img/evermart.9eaa3c62.png";